// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/Product.yaml
// Generated: 2025-11-16T16:07:00.753Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateProduct, UpdateProduct, Product } from '@/types/inventory/Product';

/**
 * Product Service
 * CRUD operations for Product via the ABP API.
 */
export const productService = new EntityService<Product, CreateProduct, UpdateProduct>(
  '/api/inventory/product',
  'Product',
);
